import React, { useState, useEffect} from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { createSocialLink, clearCreateSocialLink } from 'redux/social/actions';

import { Input } from 'semantic-ui-react';

import CommonSearchDropdownSelector
  from 'components/common/CommonSearchDropdownSelector';
import Button from 'components/elements/buttons/Button';
import CommonErrorIcon
  from 'components/common/CommonErrorIcon';

import validate from 'components/dashboard/social-content/utils-validation/validate';
import { modifyInputValue } from
  'components/dashboard/social-content/utils-validation/utils';

import './AddSocialLinkForm.css';


function AddSocialLinkForm(props) {
  const {
    socialNetworksList,
    createSocialLinkError,
    createSocialLink,
    clearCreateSocialLink,
    me,
  } = props;

  const [selectedSocial, setSelectedSocial] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [validationErrors, setValidationErrors] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedSocial) {
      setValidationErrors(null);
      clearCreateSocialLink();
    }
  }, [selectedSocial]);

  useEffect(() => {
    if (!inputValue) { setValidationErrors(null); }
    if (inputValue && validationErrors) {
      setValidationErrors(null);
    }
  }, [inputValue]);

  useEffect(() => {
    return () => {
      setSelectedSocial(null);
      setInputValue(null);
      setValidationErrors(null);
    };
  }, []);

  function addSocialLink() {
    createSocialLink({
      social_network: selectedSocial.id,
      value: modifyInputValue(inputValue, selectedSocial.type, selectedSocial.name),
    });
    setInputValue('');
  }

  function validateAndCreateLink() {
    setValidationErrors(validate(
      socialNetworksList,
      selectedSocial.type,
      selectedSocial.name.toLowerCase(),
      inputValue,
      addSocialLink,
    ));
  }

  const itemsList = socialNetworksList && socialNetworksList.map(item => ({
    id: item.id,
    type: item.type,
    name: item.name,
    icon_svg: item.icon_svg,
    form_placeholder: item.form_placeholder,
    isPro: ['App Store', 'Google Play'].includes(item.name),
    isLocked: me && me.subscription && !me.subscription.ff_mobile_app_links &&
      ['App Store', 'Google Play'].includes(item.name),
    proPlaceholder: `You can add ${item.name} link`,
  }));

  return (
    <div className="add-social-link-form__component">
      <div className="social-selector-wrapper">
        <CommonSearchDropdownSelector
          setSelectedItem={setSelectedSocial}
          itemsList={itemsList}
          searchPlaceholder={t("Select Popular Social Link")}
        />
      </div>

      <div className={`input-field-wrapper${validationErrors ? ' errors' : ''}`}>
        <Input
          disabled={!selectedSocial}
          placeholder={selectedSocial ? selectedSocial.form_placeholder : t("Paste Your Social Link here")}
          value={inputValue}
          onChange={e => {
            setInputValue(e.target.value);
          }}
        />
        {validationErrors &&
          <div className="errors">
            <CommonErrorIcon errorText={validationErrors} />
          </div>
        }
        {createSocialLinkError &&
          <div className="errors">
            <CommonErrorIcon errorText={createSocialLinkError.value} />
          </div>
        }
      </div>

      <div className="buttons-block">
        <Button
          onClick={validateAndCreateLink}
          disabled={!inputValue}
        >
          {t("+ Add")} {selectedSocial ? selectedSocial.name : t("Social Link")}
        </Button>
      </div>

    </div>
  );
};

AddSocialLinkForm.propTypes = {
  createSocialLink: PropTypes.func.isRequired,
  socialNetworksList: PropTypes.arrayOf(PropTypes.shape),
  clearCreateSocialLink: PropTypes.func.isRequired,
  createSocialLinkError: PropTypes.object,
  me: PropTypes.object,
};

AddSocialLinkForm.defaultProps = {
  socialNetworksList: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    socialNetworksList: state.socialReducer.socialNetworksList,
    createSocialLinkError: state.socialReducer.createSocialLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    createSocialLink,
    clearCreateSocialLink,
  },
)(AddSocialLinkForm);
